var map = {
	"./746": 1933,
	"./746.png": 1933,
	"./blank": 1934,
	"./blank.gif": 1934,
	"./check_flat/default": 1935,
	"./check_flat/default.png": 1935,
	"./chosen-sprite": 1936,
	"./chosen-sprite.png": 1936,
	"./chosen-sprite@2x": 1937,
	"./chosen-sprite@2x.png": 1937,
	"./credit_cards/American_Express": 1938,
	"./credit_cards/American_Express.png": 1938,
	"./credit_cards/Diners_Club": 1939,
	"./credit_cards/Diners_Club.png": 1939,
	"./credit_cards/Discover": 1940,
	"./credit_cards/Discover.png": 1940,
	"./credit_cards/JCB": 1941,
	"./credit_cards/JCB.png": 1941,
	"./credit_cards/MasterCard": 1942,
	"./credit_cards/MasterCard.png": 1942,
	"./credit_cards/Visa": 1943,
	"./credit_cards/Visa.png": 1943,
	"./default_hotel_room_icon": 1944,
	"./default_hotel_room_icon.png": 1944,
	"./desktop": 1945,
	"./desktop.png": 1945,
	"./g-logo": 1946,
	"./g-logo.png": 1946,
	"./line_chart_primary_axis": 1947,
	"./line_chart_primary_axis.png": 1947,
	"./line_chart_sample": 1948,
	"./line_chart_sample.png": 1948,
	"./line_chart_secodary_axis": 1949,
	"./line_chart_secodary_axis.png": 1949,
	"./logo": 1950,
	"./logo.png": 1950,
	"./phone": 1951,
	"./phone.png": 1951,
	"./spinner": 1952,
	"./spinner-horizontal": 1953,
	"./spinner-horizontal-balls": 1954,
	"./spinner-horizontal-balls.gif": 1954,
	"./spinner-horizontal-waves": 1955,
	"./spinner-horizontal-waves.gif": 1955,
	"./spinner-horizontal.gif": 1953,
	"./spinner.gif": 1952,
	"./tablet": 1956,
	"./tablet.png": 1956,
	"./welcome_bg_day": 1957,
	"./welcome_bg_day.png": 1957,
	"./welcome_bg_night": 1958,
	"./welcome_bg_night.png": 1958
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1968;